import React from "react";
import { Routes, Route } from "react-router-dom";
import routes, { Route as RouteType } from "routes";

export default function EvaluacionLayout() {
  const getRoutes = (routes: RouteType[]): any =>
    routes.map((route: RouteType, key: number) =>
      route.layout === "/evaluacion" ? (
        <React.Fragment key={key}>
          <Route path={`/${route.path}`} element={route.component} />
          {/* Landing de un cliente: /evaluacion/{slug} */}
          <Route path="/:slug" element={route.component} />
        </React.Fragment>
      ) : null
    );

  return <Routes>{getRoutes(routes)}</Routes>;
}
